export const LIST_NODE_CLASS_NAME = 'common-slidebar-list';
